<template>
  <div class="form-panel">     
    <div class="form-panel__header">
      <h2 class="titulo-h2">¿Dónde vives?</h2>
    </div>
    <div class="form-panel__body">        
      <transition name="prueba" mode="out-in">

        <!-- Ingreso Ciudad -->        
        <div v-if="vista == 1" key="ciudad" class="form-fields">
          <div class="form-fields__principal">
            <h2 class="titulo-h3-light">Selecciona tu municipio de residencia</h2>            
            <form class="form" action="">  
              <div class="form__group" :class="{'form__group-invalid': $v.formUbicacion.departamento.$error, 'form__group-valid': !$v.formUbicacion.departamento.$invalid}">
                <i class="icon-field icon-field-location"></i>        
                <label for="departamento">Departamento</label>
                <v-progress-linear v-if="!formUbicacion.departamentos" :indeterminate="true"></v-progress-linear>
                <v-select class="selectField" v-else :items="formUbicacion.departamentos" v-model="formUbicacion.departamento" item-text="nombre" item-value="idDepartamento" label="Select" solo @change="consultarMunicipios"></v-select>
                <div class="form__group-validation" v-if="$v.formUbicacion.departamento.$dirty">
                  <p v-if="!$v.formUbicacion.departamento.required">Selecciona un departamento.</p>
                </div>
              </div> 
              <div v-if="formUbicacion.departamento > 0" class="form__group" :class="{'form__group-invalid': $v.formUbicacion.municipio.$error, 'form__group-valid': !$v.formUbicacion.municipio.$invalid}">
                <i class="icon-field icon-field-location"></i>        
                <label for="municipio">Municipio</label>
                <v-progress-linear v-if="!formUbicacion.municipios" :indeterminate="true"></v-progress-linear>
                <v-select class="selectField" v-else :items="formUbicacion.municipios" v-model="formUbicacion.municipio" item-text="nombre" item-value="idMunicipio" label="Select" solo @change="consultarBarrios" ></v-select>
                <div class="form__group-validation" v-if="$v.formUbicacion.municipio.$dirty">
                  <p v-if="!$v.formUbicacion.municipio.minValue">Selecciona un municipio.</p>
                </div>
              </div>
              <div v-if="formUbicacion.municipio > 0" class="form__group" :class="{'form__group-invalid': $v.formUbicacion.barrio.$error, 'form__group-valid': !$v.formUbicacion.barrio.$invalid}">
                <i class="icon-field icon-field-location"></i>        
                <label for="estado">Barrio</label>
                <!--<v-progress-linear v-if="!formUbicacion.barrios" :indeterminate="true"></v-progress-linear>
                <div v-else>-->
                  <v-select class="selectField" v-if="formUbicacion.barrios" :items="formUbicacion.barrios" v-model="formUbicacion.barrio" item-text="nombre" item-value="idBarrio" label="Select" solo ></v-select>
                  <span class="opcionNoDisponible" v-else>No hay barrios disponibles.</span>
                <!--</div>                -->
                <div class="form__group-validation" v-if="$v.formUbicacion.barrio.$dirty">
                  <p v-if="!$v.formUbicacion.barrio.minValue">Selecciona un barrio.</p>
                </div>
              </div> 
            </form>          
          </div>
          <div class="form-fields__secundario">
            <h3 class="titulo-h3">Dirección Completa</h3>
            <h4 class="titulo-h4">{{ ubicacionCompleta }}</h4>
            <h4 class="titulo-h4">{{ direccionCompleta }}</h4>
          </div>   
          <div class="form-fields__navegacion">
            <a class="waves-effect waves-light m-btn form-fields__navegacion-izq m-btn-secundario" tabindex="0" @mousedown.prevent="atras()">Anterior</a>
            <a v-if="!$v.formUbicacion.$invalid" class="waves-effect waves-light m-btn form-fields__navegacion-der" tabindex="0" @click="adelante()">Continuar</a>
          </div> 
        </div>  

        <!-- Dirección -->        
        <div v-if="vista == 2" key="direccion" class="form-fields">          
          <div class="form-fields__principal">
            <h2 class="titulo-h3-light">Tipo y número de vía, ej: Calle 23 # 67 - 14</h2>            
            <form class="form" action="">  
              <div class="form__group" :class="{'form__group-invalid': $v.formDireccion.tipoVia.$error, 'form__group-valid': !$v.formDireccion.tipoVia.$invalid}">
                <i class="icon-field icon-field-location"></i>        
                <label for="departamento">Tipo Vía</label>
                <v-select class="selectField" :items="formDireccion.tiposVia" v-model="formDireccion.tipoVia" item-text="descripcion" item-value="abreviatura" label="Select" solo ></v-select>
                <div class="form__group-validation" v-if="$v.formDireccion.tipoVia.$dirty">
                  <p v-if="!$v.formDireccion.tipoVia.required">Selecciona un tipo de vía.</p>
                </div>
              </div>
              <div v-if="formDireccion.tipoVia" class="form__group form__group-doble" :class="{'form__group-invalid': $v.formDireccion.numeroVia.$error, 'form__group-valid': !$v.formDireccion.numeroVia.$invalid}">
                <i class="icon-field icon-field-street icon1"></i>        
                <label for="formDireccion.numeroVia" class="label1">Número de Vía</label>
                <input id="formDireccion.numeroVia" class="textbox1" type="text" autofocus @blur="$v.formDireccion.numeroVia.$touch()" v-model="formDireccion.numeroVia">
                <div class="form__group-validation validacion1" v-if="$v.formDireccion.numeroVia.$dirty">
                  <p v-if="!$v.formDireccion.numeroVia.required">Ingresa el número de vía.</p>
                </div>
                <i class="icon-field icon-field-placaCasa icon2"></i>        
                <label for="formDireccion.interseccion" class="label2">{{ tipoInterseccion }}</label>
                <input id="formDireccion.interseccion" class="textbox2" type="text" autofocus @blur="$v.formDireccion.interseccion.$touch()" v-model="formDireccion.interseccion">
                <div class="form__group-validation validacion2" v-if="$v.formDireccion.interseccion.$dirty">
                  <p v-if="!$v.formDireccion.interseccion.required">Ingresa la nomenclatura.</p>
                </div>
              </div>   
              <h2 v-if="formDireccion.interseccion" class="titulo-h3-light"></h2>  
              <h2 v-if="formDireccion.interseccion" class="titulo-h3-light">Residencia, ej: Unidad Villas del Sol Bloque 8 Ap 401</h2>   
              <div v-if="formDireccion.interseccion" class="form__group" :class="{'form__group-invalid': $v.formDireccion.complemento1.$error, 'form__group-valid': !$v.formDireccion.complemento1.$invalid}">
                <i class="icon-field icon-field-home"></i>        
                <label for="complemento1">Tipo Residencia</label>
                <v-select class="selectField" :items="formDireccion.opcionesComplemento1" v-model="formDireccion.complemento1" item-text="descripcion" item-value="abreviatura" label="Select" solo @change="actualizarOpcionesComplemento2"></v-select>
                <div class="form__group-validation" v-if="$v.formDireccion.complemento1.$dirty">
                  <p v-if="!$v.formDireccion.complemento1.required">Selecciona el tipo de residencia.</p>
                </div>
              </div>
              <div v-if="formDireccion.complemento1 && formDireccion.complemento1 != 'Ninguno'" class="form__group" :class="{'form__group-invalid': $v.formDireccion.complemento1Numero.$error, 'form__group-valid': !$v.formDireccion.complemento1Numero.$invalid}">
                <i class="icon-field icon-field-home"></i>        
                <label for="formDireccion.complemento1Numero">Número Residencia</label>
                <input id="formDireccion.complemento1Numero" type="text" autofocus @blur="$v.formDireccion.complemento1Numero.$touch()" v-model="formDireccion.complemento1Numero">
                <div class="form__group-validation" v-if="$v.formDireccion.complemento1Numero.$dirty">
                  <p v-if="!$v.formDireccion.complemento1Numero.requiredIf">Ingresa el número o nombre.</p>
                </div>
              </div>
              <div v-if="formDireccion.complemento1Numero && formDireccion.opcionesComplemento2 && formDireccion.complemento1 != 'Ninguno' || formDireccion.complemento1 != 'Etapa' && formDireccion.complemento1 == 'Entrada'" class="form__group" :class="{'form__group-invalid': $v.formDireccion.complemento2.$error, 'form__group-valid': !$v.formDireccion.complemento2.$invalid}">
                <i class="icon-field icon-field-home"></i>        
                <label for="complemento2">Tipo</label>
                <v-select class="selectField" :items="formDireccion.opcionesComplemento2" v-model="formDireccion.complemento2" item-text="descripcion" item-value="abreviatura" label="Select" solo @change="actualizarOpcionesComplemento3"></v-select>
                <div class="form__group-validation" v-if="$v.formDireccion.complemento2.$dirty">
                  <p v-if="!$v.formDireccion.complemento2.requiredIf">Selecciona el tipo de residencia.</p>
                </div>
              </div>
              <div v-if="formDireccion.complemento2 && formDireccion.complemento2 != 'Ninguno'" class="form__group" :class="{'form__group-invalid': $v.formDireccion.complemento2Numero.$error, 'form__group-valid': !$v.formDireccion.complemento2Numero.$invalid}">
                <i class="icon-field icon-field-home"></i>        
                <label for="formDireccion.complemento2Numero">Número</label>
                <input id="formDireccion.complemento2Numero" type="text" autofocus @blur="$v.formDireccion.complemento2Numero.$touch()" v-model="formDireccion.complemento2Numero">
                <div class="form__group-validation" v-if="$v.formDireccion.complemento2Numero.$dirty">
                  <p v-if="!$v.formDireccion.complemento2Numero.requiredIf">Ingresa el número o nombre.</p>
                </div>
              </div>
              <div v-if="formDireccion.complemento2Numero && formDireccion.opcionesComplemento3 && formDireccion.complemento1 != 'Ninguno' && formDireccion.complemento1 == 'Entrada' || formDireccion.complemento1 == 'Etapa'" class="form__group" :class="{'form__group-invalid': $v.formDireccion.complemento3.$error, 'form__group-valid': !$v.formDireccion.complemento3.$invalid}">
                <i class="icon-field icon-field-home"></i>        
                <label for="complemento3">Tipo</label>
                <v-select class="selectField" :items="formDireccion.opcionesComplemento3" v-model="formDireccion.complemento3" item-text="descripcion" item-value="abreviatura" label="Select" solo></v-select>
                <div class="form__group-validation" v-if="$v.formDireccion.complemento3.$dirty">
                  <p v-if="!$v.formDireccion.complemento3.requiredIf">Selecciona el tipo de residencia.</p>
                </div>
              </div>
              <div v-if="formDireccion.complemento3 && formDireccion.complemento3 != 'Ninguno' && formDireccion.complemento1 != 'Entrada'  && formDireccion.complemento1 != 'Etapa'" class="form__group" :class="{'form__group-invalid': $v.formDireccion.complemento3Numero.$error, 'form__group-valid': !$v.formDireccion.complemento3Numero.$invalid}">
                <i class="icon-field icon-field-home"></i>        
                <label for="formDireccion.complemento3Numero">Valor</label>
                <input id="formDireccion.complemento3Numero" type="text" autofocus @blur="!$v.formDireccion.complemento3Numero.$touch()" v-model="formDireccion.complemento3Numero">
                <div class="form__group-validation" v-if="$v.formDireccion.complemento3Numero.$dirty">
                  <p v-if="!$v.formDireccion.complemento3Numero.requiredIf">Ingresa el número o nombre.</p>
                </div>
              </div>
            </form>          
          </div>
          <div class="form-fields__secundario">
            <h3 class="titulo-h3">Dirección Completa</h3>
            <h4 class="titulo-h4">{{ ubicacionCompleta }}</h4>
            <h4 class="titulo-h4">{{ direccionCompleta }}</h4>
          </div>   
          <div class="form-fields__navegacion">
            <a class="waves-effect waves-light m-btn form-fields__navegacion-izq m-btn-secundario" tabindex="0" @mousedown.prevent="atras()">Anterior</a>
            <a v-if="!$v.formDireccion.$invalid" class="waves-effect waves-light m-btn form-fields__navegacion-der" tabindex="0" @click="guardar()">Guardar</a>
          </div> 
        </div>    
      </transition>
    </div>      
  </div>   
</template>

<script>
import axios from 'axios'
import { required, requiredIf, minLength, minValue, alpha } from 'vuelidate/lib/validators';

export default {
  data() {
    return{
      vista: 1,
      formUbicacion: {
        departamento: 0, 
        departamentos: [
          { idDepartamento: 1, nombre: 'Antioquia' },
          { idDepartamento: 2, nombre: 'Atlántico' },
          { idDepartamento: 3, nombre: 'Bogotá D.C' },
          { idDepartamento: 4, nombre: 'Bolívar' },
          { idDepartamento: 5, nombre: 'Boyacá' },
          { idDepartamento: 6, nombre: 'Caldas' },
          { idDepartamento: 7, nombre: 'Caquetá' },
          { idDepartamento: 8, nombre: 'Cauca' },
          { idDepartamento: 9, nombre: 'Cesar' },
          { idDepartamento: 10, nombre: 'Córdoba' },
          { idDepartamento: 11, nombre: 'Cundinamarca' },
          { idDepartamento: 12, nombre: 'Chocó' },
          { idDepartamento: 13, nombre: 'Huila' },
          { idDepartamento: 14, nombre: 'La Guajira' },
          { idDepartamento: 15, nombre: 'Magdalena' },
          { idDepartamento: 16, nombre: 'Meta' },
          { idDepartamento: 17, nombre: 'Nariño' },
          { idDepartamento: 18, nombre: 'Norte de Santander' },
          { idDepartamento: 19, nombre: 'Quindio' },
          { idDepartamento: 20, nombre: 'Risaralda' },
          { idDepartamento: 21, nombre: 'Santander' },
          { idDepartamento: 22, nombre: 'Sucre' },
          { idDepartamento: 23, nombre: 'Tolima' },
          { idDepartamento: 24, nombre: 'Valle del Cauca' },
          { idDepartamento: 25, nombre: 'Arauca' },
          { idDepartamento: 26, nombre: 'Casanare' },
          { idDepartamento: 27, nombre: 'Putumayo' },
          { idDepartamento: 28, nombre: 'San Andrés' },
          { idDepartamento: 29, nombre: 'Amazonas' },
          { idDepartamento: 30, nombre: 'Guainía' },
          { idDepartamento: 31, nombre: 'Guaviare' },
          { idDepartamento: 32, nombre: 'Vaupés' },
          { idDepartamento: 33, nombre: 'Vichada' }
        ],  
        municipio: 0,
        municipios: null,
        barrio: -1,
        barrios: null
      },
      formDireccion: {
        tipoVia: null,
        tiposVia: [
          { abreviatura: 'Autop', descripcion: 'Autopista' },
          { abreviatura: 'Av', descripcion: 'Avenida' },
          { abreviatura: 'Cl', descripcion: 'Calle' },
          { abreviatura: 'Cr', descripcion: 'Carrera' },
          { abreviatura: 'Carrt', descripcion: 'Carretera' },
          { abreviatura: 'Cq', descripcion: 'Circular' },
          { abreviatura: 'Dg', descripcion: 'Diagonal' },
          { abreviatura: 'Autop', descripcion: 'Autopista' },
          { abreviatura: 'Tr', descripcion: 'Transversal' },
          { abreviatura: 'Autop', descripcion: 'Autopista' }
        ],
        numeroVia: null,
        interseccion: null,
        opcionesComplemento1: [
          { abreviatura: 'Ninguno', descripcion: 'Ninguno' },
          { abreviatura: 'Ap', descripcion: 'Apartamento' },
          { abreviatura: 'B', descripcion: 'Bloque' },
          { abreviatura: 'Casa', descripcion: 'Casa' },
          { abreviatura: 'Edif', descripcion: 'Edificio' },
          { abreviatura: 'E', descripcion: 'Entrada' },
          { abreviatura: 'Esq', descripcion: 'Esquina' },
          { abreviatura: 'Et', descripcion: 'Etapa' },
          { abreviatura: 'Int', descripcion: 'Interior' },
          { abreviatura: 'Lt', descripcion: 'Lote' },
          { abreviatura: 'Manz', descripcion: 'Manzana' },
          { abreviatura: 'P', descripcion: 'Piso' },
          { abreviatura: 'Res', descripcion: 'Residencia' },
          { abreviatura: 'Secc', descripcion: 'Sección' },
          { abreviatura: 'Trr', descripcion: 'Torre' },
          { abreviatura: 'U', descripcion: 'Unidad' },
          { abreviatura: 'Urb', descripcion: 'Urbanización' }
        ],
        complemento1: null,
        complemento1Numero: null,
        opcionesComplemento2: null,
        complemento2: null,
        complemento2Numero: null,
        opcionesComplemento3: null,
        complemento3: null,
        complemento3Numero: null
      }
    };
  },
  computed: {    
    ubicacionCompleta() {
      let ub = ''

      if(this.formUbicacion.departamento > 0 && this.formUbicacion.departamentos)
      {
        ub += this.formUbicacion.departamentos.filter(d => d.idDepartamento == this.formUbicacion.departamento)[0].nombre
        if(this.formUbicacion.municipio > 0 && this.formUbicacion.municipios)
        {
          ub += ', ' + this.formUbicacion.municipios.filter(m => m.idMunicipio == this.formUbicacion.municipio)[0].nombre
          if(this.formUbicacion.barrio > 0 && this.formUbicacion.barrios)
          {
            ub += ', ' + this.formUbicacion.barrios.filter(b => b.idBarrio == this.formUbicacion.barrio)[0].nombre
          }
        }
      }

      return ub
    },
    direccionCompleta() {
      let dir = ''

      if(this.formDireccion.tipoVia) {
        dir += ' ' + this.formDireccion.tipoVia;
        if(dir && this.formDireccion.numeroVia) {
          dir += ' ' + this.formDireccion.numeroVia
          if(this.formDireccion.interseccion) {
            dir += ' ' + this.tipoInterseccion + ' ' + this.formDireccion.interseccion
            if(this.formDireccion.complemento1 && this.formDireccion.complemento1 != 'Ninguno') {
              dir += ' ' + this.formDireccion.complemento1
              if(this.formDireccion.complemento1Numero) {
                dir += ' ' + this.formDireccion.complemento1Numero
                if(this.formDireccion.complemento2) {
                  dir += ' ' + this.formDireccion.complemento2
                  if(this.formDireccion.complemento2Numero) {
                    dir += ' ' + this.formDireccion.complemento2Numero
                    if(this.formDireccion.complemento3) {
                      dir += ' ' + this.formDireccion.complemento3
                      if(this.formDireccion.complemento3Numero) {
                        dir += ' ' + this.formDireccion.complemento3Numero
                      }
                    }
                  }
                }
              }
            }
          }
        } 
      } 
      return dir
    },
    tipoInterseccion() {
      if(!this.formDireccion.tipoVia) {
        return ''
      }

      if(this.formDireccion.tipoVia == 'Autop' || this.formDireccion.tipoVia == 'Carrt') {
        return 'Km'
      }
      else {
        return '#'
      }
    }    
  },
  methods: {
    adelante() {
      this.vista++;
    },
    atras() {
      this.vista--;
    },
    guardar() {
      let direccion = {
        idDepartamento: this.formUbicacion.departamento,
        idMunicipio: this.formUbicacion.municipio,
        idBarrio: this.formUbicacion.barrio,
        tipoVia: this.formDireccion.tipoVia,
        numeroVia: this.formDireccion.numeroVia,
        interseccion: this.formDireccion.interseccion,
        complemento1: this.formDireccion.complemento1,
        complemento1Numero: this.formDireccion.complemento1Numero,
        complemento2: this.formDireccion.complemento2,
        complemento2Numero: this.formDireccion.complemento2Numero,
        complemento3Numero: this.formDireccion.complemento3Numero
      }
      if (direccion.complemento3 != null && direccion.complemento3 != ''){
          console.log(direccion.complemento3)
         direccion.complemento3 = this.formDireccion.complemento3.join()
      }else{
        direccion.complemento3 = " "
      }

      this.$store.dispatch('guardarDireccionCliente', direccion)
    },
    consultarMunicipios(idDepartamento) {
      this.formUbicacion.municipio = 0
      this.formUbicacion.municipios = null

      this.formUbicacion.barrio = -1
      this.formUbicacion.barrios = null

      axios.post('api/Configuracion/ConsultarMunicipiosDepartamento', { idDepartamento })
      .then(response => {
        this.formUbicacion.municipios = response.data
      })
      .catch(error => { console.log(error) })
    },
    consultarBarrios(idMunicipio) {
      this.formUbicacion.barrio = -1
      this.formUbicacion.barrios = null

      axios.post('api/Configuracion/ConsultarBarriosMunicipio', { idMunicipio })
      .then(response => {
        this.formUbicacion.barrios = response.data

        if(response.data.length == 0) {
          this.formUbicacion.barrio = 0
        }
      })
      .catch(error => { console.log(error) })
    },
    actualizarOpcionesComplemento2(tipoAbreviatura) {
      this.formDireccion.complemento2 = null
      this.formDireccion.complemento3 = null
      this.formDireccion.opcionesComplemento3 = []
      this.formDireccion.opcionesComplemento2 = this.obtenerComplementoDireccion(tipoAbreviatura)  
    },
    actualizarOpcionesComplemento3(tipoAbreviatura) {
      this.formDireccion.complemento3 = []
      this.formDireccion.opcionesComplemento3 = this.obtenerComplementoDireccion(tipoAbreviatura)     
    },
    obtenerComplementoDireccion(tipoAbreviatura)
    {
        if(tipoAbreviatura == 'Ninguno') {
          return null
        }

        let abreviaturas = []

        switch (tipoAbreviatura)
        {
            case 'B':
            case 'Edif':
            case 'Trr':
                abreviaturas.push({ abreviatura: 'Ap', descripcion: 'Apartamento' })
                abreviaturas.push({ abreviatura: 'Int', descripcion: 'Interior' })
                break

            case 'E':
                abreviaturas.push({ abreviatura: 'B', descripcion: 'Bloque' })
                abreviaturas.push({ abreviatura: 'Casa', descripcion: 'Casa' })
                abreviaturas.push({ abreviatura: 'Edif', descripcion: 'Edificio' })
                abreviaturas.push({ abreviatura: 'P', descripcion: 'Piso' })
                abreviaturas.push({ abreviatura: 'Res', descripcion: 'Residencia' })
                abreviaturas.push({ abreviatura: 'Trr', descripcion: 'Torre' })
                break

            case 'Et':
                abreviaturas.push({ abreviatura: 'B', descripcion: 'Bloque' })
                abreviaturas.push({ abreviatura: 'Casa', descripcion: 'Casa' })
                abreviaturas.push({ abreviatura: 'Edif', descripcion: 'Edificio' })
                abreviaturas.push({ abreviatura: 'E', descripcion: 'Entrada' })
                abreviaturas.push({ abreviatura: 'P', descripcion: 'Piso' })
                abreviaturas.push({ abreviatura: 'Res', descripcion: 'Residencia' })
                abreviaturas.push({ abreviatura: 'Trr', descripcion: 'Torre' })
                break

            case 'Lt':
            case 'Manz':
                abreviaturas.push({ abreviatura: 'B', descripcion: 'Bloque' })
                abreviaturas.push({ abreviatura: 'Casa', descripcion: 'Casa' })
                abreviaturas.push({ abreviatura: 'Edif', descripcion: 'Edificio' })
                abreviaturas.push({ abreviatura: 'E', descripcion: 'Entrada' })
                abreviaturas.push({ abreviatura: 'P', descripcion: 'Piso' })
                abreviaturas.push({ abreviatura: 'Res', descripcion: 'Residencia' })
                abreviaturas.push({ abreviatura: 'Trr', descripcion: 'Torre' })
                abreviaturas.push({ abreviatura: 'Et', descripcion: 'Etapa' })
                break

            case 'U':
            case 'Urb':
                abreviaturas.push({ abreviatura: 'B', descripcion: 'Bloque' })
                abreviaturas.push({ abreviatura: 'Casa', descripcion: 'Casa' })
                abreviaturas.push({ abreviatura: 'Edif', descripcion: 'Edificio' })
                abreviaturas.push({ abreviatura: 'E', descripcion: 'Entrada' })
                abreviaturas.push({ abreviatura: 'Et', descripcion: 'Etapa' })
                abreviaturas.push({ abreviatura: 'P', descripcion: 'Piso' })
                abreviaturas.push({ abreviatura: 'Res', descripcion: 'Residencia' })
                abreviaturas.push({ abreviatura: 'Trr', descripcion: 'Torre' })
                break

            default:
                abreviaturas = null
        }          

        return abreviaturas
    }
  },
  mounted() {
    
    this.formUbicacion.departamento = 0
    this.formUbicacion.municipio = 0
    this.formUbicacion.municipios = null
    this.formUbicacion.barrio = 0
    this.formUbicacion.barrios = null
    this.formDireccion.tipoVia = null
    this.formDireccion.numeroVia = null
    this.formDireccion.interseccion = null
    this.formDireccion.complemento1 = null
    this.formDireccion.complemento1Numero = null
    this.formDireccion.opcionesComplemento2 = []
    this.formDireccion.complemento2 = null
    this.formDireccion.complemento2Numero = null
    this.formDireccion.opcionesComplemento3 = []
    this.formDireccion.complemento3 = null
    
    if(!this.$store.getters.cliente || !this.$store.getters.cliente.direccion) {
      	return
    }

    let dir = this.$store.getters.cliente.direccion

    //console.log(dir)
    this.formUbicacion.departamento = dir.idDepartamento

    this.consultarMunicipios(dir.idDepartamento)
    
    this.formUbicacion.municipio = dir.idMunicipio
    
    this.consultarBarrios(dir.idMunicipio)

    this.formUbicacion.barrio = dir.idBarrio

    if(dir.tipoVia != null) {
      this.formDireccion.tipoVia = dir.tipoVia;
      if(dir.numeroVia != null) {
        this.formDireccion.numeroVia = dir.numeroVia
        if(dir.interseccion != null) {
          this.formDireccion.interseccion = dir.interseccion
          if(dir.complemento1 != null) {
            this.formDireccion.complemento1 = dir.complemento1
            this.actualizarOpcionesComplemento2(dir.complemento1)
            if(dir.complemento1Numero != null) {
              this.formDireccion.complemento1Numero = dir.complemento1Numero
              if(dir.complemento2 != null) {
                this.formDireccion.complemento2 = dir.complemento2
                this.actualizarOpcionesComplemento3(dir.complemento2)
                if(dir.complemento2Numero != null) {
                  this.formDireccion.complemento2Numero = dir.complemento2Numero
                   if(dir.complemento3 != null) {
                    this.formDireccion.complemento3 = dir.complemento3
                    if(dir.complemento3Numero != null) {
                      this.formDireccion.complemento3Numero = dir.complemento3Numero
                    }
                  }
                }
              }
            }
          }
        }
      } 
    }
  },
  validations() {
   return {
      formUbicacion: {
        departamento: {
          minValue: minValue(1)
        },
        municipio: {
          minValue: minValue(1)
        },
        barrio: {
          minValue: minValue(0)
        }
      },
      formDireccion: {
        tipoVia: {
          required
        },
        numeroVia: {
          required
        },
        interseccion: {
          required
        },
        complemento1: {
          required
        },
        complemento1Numero: {
          requiredIf: requiredIf(() => { 
            return this.formDireccion.complemento1 && this.formDireccion.complemento1 != 'Ninguno'
          })
        },
        complemento2: {
          requiredIf: requiredIf(() => { 
            return this.formDireccion.opcionesComplemento2 && this.formDireccion.opcionesComplemento2.length > 0
          })
        },
        complemento2Numero: {
          requiredIf: requiredIf(() => { 
            return this.formDireccion.opcionesComplemento2 && this.formDireccion.opcionesComplemento2.length > 0
          })
        },
        complemento3: {
          requiredIf: requiredIf(() => { 
            return this.formDireccion.opcionesComplemento3 && this.formDireccion.opcionesComplemento3.length > 0 
            
          })
        },
        complemento3Numero: {
          requiredIf: requiredIf(() => { 
            return this.formDireccion.opcionesComplemento3 && this.formDireccion.opcionesComplemento3.length > 0
          })
        }
      }
    }
  }
}
</script>

